import { useFormState } from 'react-hook-form';
export function useReactHookFormFormError() {
    const { errors } = useFormState();
    // handle both v1 and v2 error key
    return (errors?.['_error'] || errors?.['Error']);
}
